module.exports = __webpack_public_path__ + "img/bz.b3d36ab7.svg";